import { connect } from 'react-redux';

import type { TableColumn } from '../../enums/TableColumn';
import { ConnectedTableHead } from '../header/TableHead';
import { getStateChangeColumns } from './stateChangesColumnService';

const mapStateToProps = (): { columns: TableColumn[] } => ({
    columns: getStateChangeColumns(),
});

export const StateChangesTableHeadContainer = connect(mapStateToProps)(ConnectedTableHead);
